module.exports = __webpack_public_path__ + "img/arqu-cabc-04.7523daf7.jpg";